module.exports = __webpack_public_path__ + "img/icon-status-success.259a7332.svg";